import { createContext } from 'react';
import { sentry } from '@frontend/tracking';

type StepContextType = {
  onCancelClick: () => void;
  onBackClick: () => void;
  onClose: () => void;
};

export const StepContext = createContext<StepContextType>({
  onCancelClick: () => {
    console.warn('onCancelClick not provided');
    sentry.warn({
      error: 'onCancelClick not provided',
      topic: 'phone-config',
    });
  },
  onBackClick: () => {
    console.warn('onBackClick not provided');
    sentry.warn({
      error: 'onBackClick not provided',
      topic: 'phone-config',
    });
  },
  onClose: () => {
    console.warn('onClose not provided');
    sentry.warn({
      error: 'onClose not provided',
      topic: 'phone-config',
    });
  },
});
